import styled from 'styled-components';

export const StyledBlogCategoriesList = styled.div`
  position: relative;
  border-radius: 20px;
  padding: 32px;
  background: ${({ theme }) => theme.colors.athensGray};

  .categories-list {
    &__title {
      margin-bottom: 24px;
    }

    &__categories {
      display: flex;
      flex-direction: column;
      gap: 10px;

      &__category {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 0;
        cursor: pointer;
        transition: all ease 0.3s;

        &:not(:last-child) {
          border-bottom: 1px solid ${({ theme }) => theme.colors.mercury};
        }

        &__icon {
          color: ${({ theme }) => theme.colors.raven};
          transition: color ease 0.3s;
        }

        &__text {
          flex: 1;

          label {
            transition: color ease 0.3s;
          }
        }

        &__count {
          label {
            opacity: 0.6;
          }
        }

        &:hover {
          .categories-list__categories__category__icon {
            color: ${({ theme }) => theme.colors.mainOrange};
          }

          .categories-list__categories__category__text {
            label {
              color: ${({ theme }) => theme.colors.mainOrange};
            }
          }
        }
      }
    }
  }
`;
